var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 3.99999C2.3999 3.57565 2.56847 3.16868 2.86853 2.86862C3.16859 2.56856 3.57556 2.39999 3.9999 2.39999H11.9999C12.4242 2.39999 12.8312 2.56856 13.1313 2.86862C13.4313 3.16868 13.5999 3.57565 13.5999 3.99999V12C13.5999 12.4243 13.4313 12.8313 13.1313 13.1314C12.8312 13.4314 12.4242 13.6 11.9999 13.6H3.9999C3.57556 13.6 3.16859 13.4314 2.86853 13.1314C2.56847 12.8313 2.3999 12.4243 2.3999 12V3.99999ZM11.1999 4.79999H4.7999V11.2L7.9999 9.59999L11.1999 11.2V4.79999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAlt);
export default __webpack_public_path__ + "static/media/BookmarkAlt.430e3b284ed6788447616fd3cd785b60.svg";
export { ForwardRef as ReactComponent };